var icon = require('vue-svgicon')
icon.register({
  'ionicons/ios-plus-empty': {
    width: 512,
    height: 512,
    viewBox: '0 0 512 512',
    data: '<path pid="0" d="M384 265H264v119h-17V265H128v-17h119V128h17v120h120v17z"/>'
  }
})



// WEBPACK FOOTER //
// ./src/components/generated_svg_icons/ionicons/ios-plus-empty.js